import { axiosPrivate } from "api/axiosCore";

export const serviceGetUserLeads = async (
  token,
  roleFunctions,
  departmentId,
  page,
  userPerPage,
  query,
  userId = "",
) => {
  roleFunctions = roleFunctions || [];
  departmentId = departmentId || "";

  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    let basicUrl = `api/users?take=50&c=OR&f=role.name,role.name&q=SALES,CS&departmentId=${departmentId}`;
    if (roleFunctions.includes("Access_Own")) {
      basicUrl = `api/users/${userId}`;
    }

    let response = await axiosPrivate.get(basicUrl);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceGetTicketLeads = async (
  token,
  roleFunctions,
  departmentId,
  userId,
  page,
  filterStatus,
  selectedSort = "ticket.updatedAt",
  sortDir = "DESC",
  customerPhone = "",
  lastInteractionRange = "",
) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    roleFunctions = roleFunctions || [];
    departmentId = departmentId || "";
    let basicUrl = `api/tickets/leads?take=10&page=${page || 1}&excludeBot=true`;
    var response = null;
    basicUrl += `&departmentId=${departmentId}`;
    basicUrl += `&userId=${userId}`;
    basicUrl += `&fo=${selectedSort !== "" ? selectedSort : "ticket.updatedAt"}`;
    basicUrl += `&order=${sortDir}`;

    let f = "";
    let c = "";

    if (filterStatus !== "") {
      c += `&status=${filterStatus}`;
    }

    if (lastInteractionRange) {
      c += `&lastInteractionRange=${encodeURIComponent(lastInteractionRange)}`;
    }

    const normalizedCustomerPhone = (customerPhone || "").trim();
    if (normalizedCustomerPhone !== "") {
      const encodedCustomerPhone = encodeURIComponent(normalizedCustomerPhone);
      f += `&q=${encodedCustomerPhone}&f=chat.customerPhone&c=AND&t=CONTAIN`;
    }

    response = await axiosPrivate.get(basicUrl + f + c);

    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};

export const serviceExportLeads = async (
  token,
  departmentId,
  userId,
  filterStatus,
  selectedSort = "ticket.updatedAt",
  sortDir = "DESC",
  customerPhone = "",
  lastInteractionRange = "",
) => {
  try {
    axiosPrivate.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${token}`;
      return config;
    });

    departmentId = departmentId || "";
    let url = `api/tickets/leads/export?excludeBot=true`;
    url += `&departmentId=${departmentId}`;
    if (userId) url += `&userId=${userId}`;
    url += `&fo=${selectedSort || "ticket.updatedAt"}`;
    url += `&order=${sortDir}`;

    if (filterStatus) url += `&status=${filterStatus}`;
    if (lastInteractionRange) url += `&lastInteractionRange=${encodeURIComponent(lastInteractionRange)}`;

    if (customerPhone && customerPhone.trim()) {
      url += `&q=${encodeURIComponent(customerPhone.trim())}&f=chat.customerPhone&c=AND&t=CONTAIN`;
    }

    const response = await axiosPrivate.get(url, { responseType: "blob" });
    return response;
  } catch (error) {
    if (!error.response) {
      return { status: "No Server Response" };
    } else {
      return error.response;
    }
  }
};
